import { useEffect } from 'react';
import { clearAllApiAuthTokens } from '../../API/services/AxiosAPIService';
import { clearActiveFleetId } from '../fleetStorage';
import {
  registerAuthStateCleaner,
  registerSignOutHandler,
  subscribeToCrossTabLogout,
  triggerLogout,
} from '../authSync';

function useCrossTabAuthSync(signOut: () => void): void {
  useEffect(() => {
    const unregisterAuthStateCleaner = registerAuthStateCleaner(() => {
      clearActiveFleetId();
      clearAllApiAuthTokens();
    });
    const unregisterSignOutHandler = registerSignOutHandler(signOut);
    const unsubscribeFromCrossTabLogout = subscribeToCrossTabLogout(() => {
      triggerLogout({ broadcast: false });
    });

    return () => {
      unregisterAuthStateCleaner();
      unregisterSignOutHandler();
      unsubscribeFromCrossTabLogout();
    };
  }, [signOut]);
}

export default useCrossTabAuthSync;
